import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    items: [],
    loading: false,
    error: null,
};

const blogsSlice = createSlice({
    name: "blogs",
    initialState,
    reducers: {
        setLoading: (state) => { state.loading = true; state.error = null; },
        setItems: (state, action) => { state.loading = false; state.items = Array.isArray(action.payload) ? action.payload : []; },
        addItem: (state, action) => { state.items.unshift(action.payload); },
        updateItem: (state, action) => {
            const i = state.items.findIndex(b => b.id === action.payload.id);
            if (i !== -1) state.items[i] = action.payload;
        },
        removeItem: (state, action) => { state.items = state.items.filter(b => b.id !== action.payload); },
        setError: (state, action) => { state.loading = false; state.error = action.payload; },
    },
});

export const { setLoading, setItems, addItem, updateItem, removeItem, setError } = blogsSlice.actions;
export default blogsSlice.reducer;
